// extracted by mini-css-extract-plugin
export default {"footerBtns":"AddPayoutMethod_footerBtns__wvjm+","modalContent":"AddPayoutMethod_modalContent__D-b9T","mb24":"AddPayoutMethod_mb24__B8VtU"};